
    import './styles.scoped.css';
    export default {
  "tabs-header": "awsui_tabs-header_14rmt_1sfab_186",
  "tabs-header-list": "awsui_tabs-header-list_14rmt_1sfab_192",
  "pagination-button": "awsui_pagination-button_14rmt_1sfab_209",
  "pagination-button-left": "awsui_pagination-button-left_14rmt_1sfab_214",
  "pagination-button-left-scrollable": "awsui_pagination-button-left-scrollable_14rmt_1sfab_217",
  "pagination-button-right": "awsui_pagination-button-right_14rmt_1sfab_221",
  "pagination-button-right-scrollable": "awsui_pagination-button-right-scrollable_14rmt_1sfab_224",
  "tabs-tab": "awsui_tabs-tab_14rmt_1sfab_229",
  "tabs-tab-label": "awsui_tabs-tab-label_14rmt_1sfab_240",
  "tabs-tab-link": "awsui_tabs-tab-link_14rmt_1sfab_256",
  "tabs-tab-disabled": "awsui_tabs-tab-disabled_14rmt_1sfab_313",
  "refresh": "awsui_refresh_14rmt_1sfab_330",
  "tabs-tab-active": "awsui_tabs-tab-active_14rmt_1sfab_344",
  "tabs-header-with-divider": "awsui_tabs-header-with-divider_14rmt_1sfab_351",
  "root": "awsui_root_14rmt_1sfab_355",
  "tabs": "awsui_tabs_14rmt_1sfab_186",
  "tabs-content-wrapper": "awsui_tabs-content-wrapper_14rmt_1sfab_372",
  "with-paddings": "awsui_with-paddings_14rmt_1sfab_372",
  "tabs-container-content-wrapper": "awsui_tabs-container-content-wrapper_14rmt_1sfab_376",
  "tabs-content": "awsui_tabs-content_14rmt_1sfab_372",
  "tabs-content-active": "awsui_tabs-content-active_14rmt_1sfab_384"
};
  